module.exports = __webpack_public_path__ + "static/img/mzjj_border.27a4bfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/goodsItem/mzjj_border.png
// module id = o2w5
// module chunks = 7